import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { csvDownloadDataAtom } from '@/atoms/exporting';
import { clientOrderParamsAtom } from '@/atoms/general';
import { unwrappedMetricLookupMapAtom } from '@/atoms/queries/metric';
import { metricValueModeAtom, visibleTableColumnsAtom } from '@/atoms/table';
import { tableColumnsToUrlParam } from '@/components/export/Export.helper';
import { convertFilterParamsToString } from '@/utils/api';
import { getDataKeyFromColumnKey, getOnDemandIncludeParams } from '@/utils/metrics';

export const useCsvUrl = () => {
  const {
    i18n: { language },
  } = useTranslation('csv');
  const { url, includeOnDemandMetrics, appliedFilters } = useAtomValue(csvDownloadDataAtom);
  // clientOrderParams will always get updated when the server order params update but not vice-versa so we
  // should always use clientOrderParams to drive the csv ordering
  const clientOrderParams = useAtomValue(clientOrderParamsAtom);
  const tableColumns = useAtomValue(visibleTableColumnsAtom);
  const metricValueMode = useAtomValue(metricValueModeAtom);
  const metricLookupMap = useAtomValue(unwrappedMetricLookupMapAtom);

  const formattedTableColumns = tableColumns.map(column =>
    getDataKeyFromColumnKey(column, metricLookupMap, metricValueMode),
  );

  const selectedTableColumns = tableColumnsToUrlParam(formattedTableColumns);

  const csvQueryParams = {
    lang: language,
    order_by: clientOrderParams.order_by,
    columns: selectedTableColumns || [],
    ...(includeOnDemandMetrics &&
      getOnDemandIncludeParams({
        metricKeys: tableColumns,
        orderBy: clientOrderParams.order_by,
        filters: appliedFilters,
      })),
  };

  const csvParamsString = convertFilterParamsToString(csvQueryParams);
  const formattedParams = url.includes('?') ? csvParamsString.replace('?', '&') : csvParamsString;

  const formattedUrl = `${url}${formattedParams}`;

  return formattedUrl;
};
